module.exports = require("warning");


//////////////////
// WEBPACK FOOTER
// external "warning"
// module id = 11
// module chunks = 0